import React from 'react'
import ReactDOM from 'react-dom/client'
import { Agentation } from 'agentation'
import { LandingApp } from './LandingApp'
import { captureLandingError, initLandingTelemetry } from './telemetry'
import './marketing.css'

initLandingTelemetry()
const AgentationToolbar = Agentation as unknown as React.ComponentType

class RootErrorBoundary extends React.Component<
  { children: React.ReactNode },
  { hasError: boolean; message: string }
> {
  state = { hasError: false, message: '' }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, message: error.message || 'Unknown render error' }
  }

  override componentDidCatch(error: Error, info: React.ErrorInfo) {
    captureLandingError(error, { componentStack: info.componentStack })
  }

  override render() {
    if (!this.state.hasError) return this.props.children
    return (
      <main style={{ padding: '24px', fontFamily: 'Space Grotesk, sans-serif' }}>
        <h1 style={{ margin: 0, fontSize: '24px' }}>Landing page failed to render</h1>
        <p style={{ marginTop: '12px', color: '#4b5563' }}>{this.state.message}</p>
      </main>
    )
  }
}

const root = document.getElementById('root')

if (!root) {
  captureLandingError(new Error('Root element #root not found'))
  throw new Error('Root element #root not found')
}

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <RootErrorBoundary>
      <LandingApp />
      {import.meta.env.DEV ? <AgentationToolbar /> : null}
    </RootErrorBoundary>
  </React.StrictMode>,
)
